import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class AuthManageApi{

	static QUERY_MY_PREVILEDGE_MENU_TREE_API_URL = appConfig.gatewayUrl+appConfig.authServicePath+"/auth/my_app_previledge";
	static QUERY_OPER_GROUP_PREVILEDGE_MENU_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/operGroup/menu";
    static QUERY_OPER_GROUP_PREVILEDGE_DEPT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/operGroup/dept";
    
	
	static UPDATE_OPER_GROUP_PREVILEDGE_MENU_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/operGroup/menu";
	static UPDATE_OPER_GROUP_PREVILEDGE_DEPT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/operGroup/dept";
	
	
	static QUERY_OPER_PRIVILEDGE_DEPT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/oper/dept";
    static QUERY_OPER_BELONG_OPER_GROUP_PRIVILEDGE_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/oper/belongGroup";
    static QUERY_OPER_PREVILEDGE_ORG_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/oper/org";
	
	static UPDATE_OPER_BELONG_GROUP_PREVILEDGE_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/oper/belongGroup";
    static UPDATE_OPER_PREVILEDGE_DEPT_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/oper/dept";
    static UPDATE_OPER_PREVILEDGE_ORG_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/authManage/oper/org";
	
	//获取所有有权限的树形结构菜单
	static queryPreviledgeMenuTree(){
		let params={};
		return httpGet(AuthManageApi.QUERY_MY_PREVILEDGE_MENU_TREE_API_URL,params);
	}
	
	//查询操作员组菜单权限
	static queryOperGroupPriviledgeMenu(appId,operGroupId){
		let params={appId:appId,operGroupId:operGroupId};
		return httpGet(AuthManageApi.QUERY_OPER_GROUP_PREVILEDGE_MENU_API_URL,params);
	}
	
	//查询操作员组部门权限
	static queryOperGroupPriviledgeDept(operGroupId){
		let params={operGroupId:operGroupId};
		return httpGet(AuthManageApi.QUERY_OPER_GROUP_PREVILEDGE_DEPT_API_URL,params);
	}
	
	//修改操作员组的菜单权限
	static updateOperGroupPreviledgeMenu(operGroupId,appId,menus){
		let params={appId:appId,operGroupId:operGroupId,menus:menus};
		return httpPost(AuthManageApi.UPDATE_OPER_GROUP_PREVILEDGE_MENU_API_URL,params);
	}
	
	//修改操作员组的部门权限
	static updateOperGroupPreviledgeDept(operGroupId,depts){
		let params={operGroupId:operGroupId,departments:depts};
		return httpPost(AuthManageApi.UPDATE_OPER_GROUP_PREVILEDGE_DEPT_API_URL,params);
	}
	
	//查询操作员部门权限
	static queryOperPriviledgeDept(operId){
		let params={operId:operId};
		return httpGet(AuthManageApi.QUERY_OPER_PRIVILEDGE_DEPT_API_URL,params);
	}
	
	//查询操作员所属操作员组权限
	static queryOperBelongOperGroupPriviledge(operId){
		let params={operId:operId};
		return httpGet(AuthManageApi.QUERY_OPER_BELONG_OPER_GROUP_PRIVILEDGE_API_URL,params);
	}
	
	//保存操作员所属操作员组权限
	static updateOperBelongOperGroupPreviledge(operId,operGroups){
		let params={operId:operId,operGroups:operGroups};
		return httpPost(AuthManageApi.UPDATE_OPER_BELONG_GROUP_PREVILEDGE_API_URL,params);
	}
	
	//保存操作员部门权限
	static updateOperPreviledgeDept(operId,depts){
		let params={operId:operId,departments:depts};
		return httpPost(AuthManageApi.UPDATE_OPER_PREVILEDGE_DEPT_API_URL,params);
    }
    

    //查询操作员组织权限
	static queryOperOrgPriviledge(operId){
		let params={operId:operId};
		return httpGet(AuthManageApi.QUERY_OPER_PREVILEDGE_ORG_API_URL,params);
	}
	
	//保存操作员所属操作员组权限
	static updateOperPreviledgeOrg(operId,orgs){
		let params={operId:operId,orgs:orgs};
		return httpPost(AuthManageApi.UPDATE_OPER_PREVILEDGE_ORG_API_URL,params);
	}
	
}